// ============================================================
// DifficultySelector - RAW difficulty ladder dropdown + custom
// ± modifier input for characteristic/skill test rolls. Shared
// by the attacker and defender action sheets; each sheet owns
// its own selection state (per-panel difficulty is a feature).
// ============================================================
import { memo } from 'react';
import clsx from '../utils/clsx';
import common from '../styles/common.module.css';
import styles from '../styles/ActionSheet.module.css';
import { DIFFICULTY_LADDER } from '../engine/characteristicTests';
import NumberInput from './NumberInput';

interface DifficultySelectorProps {
  difficultyId: string;
  customMod: number;
  onDifficultyChange: (id: string) => void;
  onCustomModChange: (mod: number) => void;
}

const fmtMod = (n: number): string => (n >= 0 ? `+${n}` : String(n));

function DifficultySelector({
  difficultyId,
  customMod,
  onDifficultyChange,
  onCustomModChange,
}: DifficultySelectorProps) {
  return (
    <div className={styles.difficultyRow}>
      <span>Difficulty:</span>
      <select
        className={clsx(common.input, styles.difficultySelect)}
        aria-label="Test difficulty"
        value={difficultyId}
        onChange={(e) => onDifficultyChange(e.target.value)}
      >
        {DIFFICULTY_LADDER.map((step) => (
          <option key={step.id} value={step.id}>
            {step.label} ({fmtMod(step.mod)})
          </option>
        ))}
      </select>
      <span>±</span>
      <NumberInput
        className={clsx(common.input, styles.customModInput)}
        step={5}
        allowNegative
        aria-label="Custom test modifier"
        value={customMod}
        onChange={onCustomModChange}
      />
    </div>
  );
}

export default memo(DifficultySelector);
